import React, { Component } from "react";
import { connect } from 'react-redux';
import { Fragment } from 'react'
import { Transition } from '@headlessui/react'
import { Menu } from '@headlessui/react'
import { FaRegUserCircle } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  logout = (url) => {
    window.sessionStorage.removeItem('user');
    window.localStorage.removeItem('user');
    this.props.history.push(url);
    setTimeout(() => {
    }, 150);
  }
  logoutSubmit = (data) => {

    confirmAlert({
      title: 'Confirm to submit?',
      message: 'Are you sure want to logout.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.logout('/')
        },
        {
          label: 'No'
        }
      ]
    });
  }

  classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }

  render() {

    return (
      <>
        <div className="relative z-[100] bg-[#95CCC5]">
          <div className="flex justify-between  items-center px-4 py-4">
            <div className=" px-20">
              <img className=" w-14 scale-[3]" src="https://www.urphysio.in/img/logo3.webp" alt="logo" />
            </div>

            <div className="items-center py-2">
              <Menu as="div" className="relative  text-left flex lg:space-x-4 space-x-1 items-center">
                {({ open }) => (
                  <>
                    <div className="lg:ml-6  relative pt-2 pr-2"
                    >
                      <Menu.Button className="max-w-xs flex lg:space-x-1 items-center text-sm rounded-full focus:outline-none focus:shadow-outline">

                        <FaRegUserCircle className="text-[#005F60]" size={25} />
                      </Menu.Button>
                    </div>
                    <Transition show={open} as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95">
                      <Menu.Items static className="origin-top-right  absolute right-0 mt-2 w-44 top-8 font-medium rounded-md shadow-3xl bg-[#fff] border-[] ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                          <Menu.Item>
                            {({ active }) =>
                            (<span onClick={() => this.logoutSubmit('/login')} className={this.classNames(active ? 'bg-red-500 text-red-500 hover:bg-[#005F60] hover:text-white' : 'text-red-500 ', 'transition ease-in-out duration-500 cursor-pointer block px-4 py-1 font-semibold text-sm')}>Logout</span>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </>
                )}
              </Menu>
            </div>
          </div>
        </div>
      </>
    )
  }
}
function mapStateToProps(state) {
  const { loggingIn, user, otpSent } = state.authentication;
  const { users } = state;
  return {
    loggingIn,
    otpSent,
    user,
    users
  };
}
export default withRouter(connect(mapStateToProps)(Header));
// export default NetworkDetector(connect(mapStateToProps)(Header));

// export default withRouter(Sidebar);
